<br>


<div class="col-md-12" style="min-width: 2000px;">
  <p-table #dt [columns]="cols" [value]="records" [paginator]="false" [autoLayout]="true">


    <i *ngIf="loading" class="fa fa-spinner fa-spin"></i>

    <ng-template pTemplate="caption">
      <p class="rubrik">Koppla Systembehörigheter <-> Behörighetsroll</p>
     <div class="d-flex justify-content-start gap-2"><button class="btn border" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border" (click)="exportToCSV()">Excel</button></div>
<br>




     <div>


            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
<span class="ms-2">Antal poster: {{records?.length}} </span>

          </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr style="background-color: whitesmoke;font-weight:bold;border:1px solid lightgrey;"><td colspan="4" style="border:1px solid lightgrey;">Utskott</td><td colspan="2" style="border:1px solid lightgrey;">Institution</td><td colspan="5" style="border:1px solid lightgrey;">Ämbete</td><td colspan="4" style="border:1px solid lightgrey;">Ämbetstyp</td><td colspan="3" style="border:1px solid lightgrey;"></td></tr>
<tr>

            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>

            </th>
            <th>Action</th>
        </tr>
        <tr *ngIf="types.length > 0">
          <i *ngIf="loading" class="fa fa-spinner fa-spin mt-2 ms-1" style="font-size: 2em;color:#920000;"></i>
            <th *ngFor="let col of columns" [ngSwitch]="col.field">
                <input *ngSwitchCase="'committeeAbbreviation'" pInputText type="text" [value]="dt.filters['committeeAbbreviation'] ? dt.filters['committeeAbbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                <input *ngSwitchCase="'committeeName'" pInputText type="text" [value]="dt.filters['committeeName'] ? dt.filters['committeeName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                <input *ngSwitchCase="'institutionTypeName'" pInputText type="text" [value]="dt.filters['institutionTypeName'] ? dt.filters['institutionTypeName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                <input *ngSwitchCase="'institutionShortName'" pInputText type="text" [value]="dt.filters['institutionShortName'] ? dt.filters['institutionShortName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                <input *ngSwitchCase="'officeAbbreviation'" pInputText type="text" [value]="dt.filters['officeAbbreviation'] ? dt.filters['officeAbbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                <input *ngSwitchCase="'officeName'" pInputText type="text" [value]="dt.filters['officeName'] ? dt.filters['officeName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                <input *ngSwitchCase="'officeEmail'" pInputText type="text" [value]="dt.filters['officeEmail'] ? dt.filters['officeEmail'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                <!--input *ngSwitchCase="'officeTypeId'" pInputText type="text" [value]="dt.filters['officeTypeId'] ? dt.filters['officeTypeId'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%"-->
                <input *ngSwitchCase="'officeTypeAbbreviation'" pInputText type="text" [value]="dt.filters['officeTypeAbbreviation'] ? dt.filters['officeTypeAbbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                <!--p-dropdown appendTo="body" *ngSwitchCase="'roleDescription'" [options]="roles" [style]="{'width':'100%'}" (onChange)="dt.filter($event.value, 'roleId', 'equals')"></p-dropdown-->
                <p-select appendTo="body" *ngSwitchCase="'officeTypeName'" [options]="types" [style]="{'width':'100%', 'height':'40px'}" (onChange)="dt.filter($event.value, 'officeTypeId', 'equals')"></p-select>
              </th>
<th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
        <tr [pSelectableRow]="rowData">

            <td *ngFor="let col of columns">

              <span *ngIf="rowData[col.field]!==true && rowData[col.field]!==false">{{rowData[col.field]}}</span>
                <span *ngIf="rowData[col.field] === true">
                  <i class="fa fa-check" aria-hidden="true" style="color:green;"></i>
                </span>

                <span *ngIf="rowData[col.field] === false">
                  <i class="fa fa-times" aria-hidden="true" style="color:red;"></i>
                </span>
            </td>
            <!--td style="text-align: center;"><i class="pi pi-pencil" style="font-size:12px;" (click)="edit(rowData)" title="Ändra orsak"></i></td-->
            <td><span style="display: inline-block;"><i class="fa fa-edit" style="font-size:12px;margin-left:10px;" (click)="edit(rowData)" title="Ändra behörighetsroll för aktuell rad"></i></span></td>

        </tr>


    </ng-template>
</p-table>

</div>

<p-dialog header="Editera behörighetsroll" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-connect-accesses-and-roles-edit [formdata]="formdata" (doSave)="saveAccessAndRoleConnection($event)" (doCancel)="cancelEdit()"></app-admin-connect-accesses-and-roles-edit>
</p-dialog>




